import React from 'react'
import EditableProjectTable from './EditableProjectTable'
import './Dashboard.css'

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div className="container mx-auto px-6 py-4">
          <h1 className="text-3xl font-bold text-gray-900">Internal Project Dashboard</h1>
          <p className="text-gray-600 mt-2">Client project management and tracking</p>
        </div>
      </div>
      <div className="dashboard-content">
        <EditableProjectTable />
      </div>
    </div>
  )
}

export default Dashboard 